<template>
  <footer class="container mx-auto px-4 py-8">
    <div class="flex flex-col items-center gap-8 md:grid md:grid-cols-3 md:items-center">
      <!-- Left: Vault logo + socials + ccleaf logo -->
      <div class="flex flex-col space-y-6 items-center md:items-start">
        <div class="flex items-center gap-1">
        <img src="@/assets/logos/vault_logo.png" alt="Vault" class="h-[100px] w-auto -ml-3" />
        <div class="flex space-x-4 -ml-2">
          <a href="https://www.youtube.com/@ccleaf" class="hover:text-gray-400">
            <img src="@/assets/icons/youtube.svg" alt="YouTube" class="w-5 h-5" />
          </a>
          <a href="https://x.com/ccLeafOfficial" class="hover:text-gray-400">
            <img src="@/assets/icons/x.svg" alt="X" class="w-5 h-5" />
          </a>
          <a href="https://discord.gg/ccleaf" class="hover:text-gray-400">
            <img src="@/assets/icons/discord.svg" alt="Discord" class="w-5 h-5" />
          </a>
          <a href="https://instagram.com/ccleaf" class="hover:text-gray-400" aria-label="Instagram">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
              <path d="M12 2.2c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.22.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.05.41 2.22.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.22-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.05.36-2.22.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.22-.41-.56-.22-.96-.48-1.38-.9-.42-.42-.68-.82-.9-1.38-.16-.42-.36-1.05-.41-2.22C2.21 15.58 2.2 15.2 2.2 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.22.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.05-.36 2.22-.41C8.42 2.21 8.8 2.2 12 2.2zm0 5.63a4.17 4.17 0 1 0 0 8.34 4.17 4.17 0 0 0 0-8.34zm0 6.88a2.71 2.71 0 1 1 0-5.42 2.71 2.71 0 0 1 0 5.42zm5.3-7.05a.97.97 0 1 1-1.95 0 .97.97 0 0 1 1.95 0z"/>
            </svg>
          </a>
          <a href="https://bsky.app/profile/ccleaf.com" class="hover:text-gray-400" aria-label="Bluesky">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
              <path d="M5.5 4c2.4 1.8 5 5.5 6 7.5 1-2 3.6-5.7 6-7.5 1.8-1.3 4.5-2.3 4.5.7 0 .6-.4 5.1-.6 5.8-.6 2.6-3.3 3.2-5.7 2.8 4.2.7 5.3 3.1 3 5.4-4.4 4.5-6.4-1.1-6.9-2.6l-.3-.8-.3.8c-.5 1.5-2.5 7.1-6.9 2.6-2.3-2.3-1.2-4.7 3-5.4-2.4.4-5.1-.2-5.7-2.8-.2-.7-.6-5.2-.6-5.8 0-3 2.7-2 4.5-.7z"/>
            </svg>
          </a>
        </div>
        </div>
        <div class="flex items-center space-x-2">
          <img src="@/assets/logos/ccleaf_logo.png" alt="ccLeaf" class="h-8 w-auto" />
          <div class="text-sm">
            <div>&copy; 2025-{{ currentYear }} ccLeaf</div>
            <div class="text-gray-500">All Rights Reserved</div>
          </div>
        </div>
      </div>

      <!-- Middle: nav -->
      <div class="flex flex-col space-y-3 text-center md:justify-self-center">
        <div class="flex flex-wrap justify-center gap-x-8 gap-y-2">
          <a href="https://ccleaf.com" class="hover:text-gray-400">ccLeaf</a>
          <a href="https://ccleaf.com/about" class="hover:text-gray-400">About</a>
          <a href="https://ccleaf.com/plans" class="hover:text-gray-400">Plans</a>
        </div>
        <div class="flex flex-wrap justify-center gap-x-8 gap-y-2">
          <a href="https://app.ccleaf.com/affiliates" class="hover:text-gray-400">Affiliate Partnership</a>
          <a href="https://app.ccleaf.com/contact/" class="hover:text-gray-400">Contact</a>
        </div>
      </div>

      <!-- Right: legal -->
      <div class="flex flex-col space-y-3 text-center md:text-right md:justify-self-end">
        <a href="https://app.ccleaf.com/legal/terms" class="hover:text-gray-400">Terms of Use</a>
        <a href="https://app.ccleaf.com/legal/privacy-policy" class="hover:text-gray-400">Privacy Policy</a>
        <a href="https://app.ccleaf.com/legal/refund-policy" class="hover:text-gray-400">Refund Policy</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
}
</script>

<style scoped>
a {
  display: inline-block;
  transition: color 200ms;
}

a.flex {
  display: flex;
}

a:hover {
  color: gray;
}

img {
  transition: filter 200ms;
}

a:hover img {
  filter: brightness(0.7);
}
</style>
